export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
};

export type AdminUserCGType = {
  __typename?: 'AdminUser';
  id: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type AdminUserInputCGType = {
  /**  비밀번호 */
  password: Scalars['String']['input'];
  /**  사용자 ID */
  userId: Scalars['String']['input'];
};

/**  시설 타입 */
export type AmenityCGType = {
  __typename?: 'Amenity';
  /**  시설 이미지 URL */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /**  시설 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /**  시설 값 */
  value?: Maybe<Scalars['String']['output']>;
};

/**  기사 타입 */
export type ArticleCGType = {
  __typename?: 'Article';
  /**  원본 출처 */
  source?: Maybe<Scalars['String']['output']>;
  /**  제목 */
  title?: Maybe<Scalars['String']['output']>;
  /**  링크 */
  url?: Maybe<Scalars['String']['output']>;
};

export enum BusinessStatusCGType {
  ClosedPermanentlyCGType = 'CLOSED_PERMANENTLY',
  ClosedTemporarilyCGType = 'CLOSED_TEMPORARILY',
  OperationalCGType = 'OPERATIONAL',
}

/**  도시 타입 */
export type CityCGType = {
  __typename?: 'City';
  /**  도시 국가 */
  country?: Maybe<Scalars['String']['output']>;
  /**  도시 아이디 */
  id: Scalars['ID']['output'];
  /**  도시 메인 이미지 URL */
  mainImageUrl: Scalars['String']['output'];
  /**  도시 이름 */
  name: Scalars['String']['output'];
  /**  도시 영역 */
  zone?: Maybe<ZoneCGType>;
};

/**  도시 타입 */
export type CityMainImageUrlArgsCGType = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**  역할 */
export enum CoEditRoleCGType {
  EditCGType = 'EDIT',
  OwnerCGType = 'OWNER',
  ReadCGType = 'READ',
}

export type CoEditUserCGType = {
  __typename?: 'CoEditUser';
  /**  사용자 ID */
  id?: Maybe<Scalars['ID']['output']>;
  /**  역할 */
  role?: Maybe<CoEditRoleCGType>;
  /**  사용자 */
  user?: Maybe<UserCGType>;
};

/**  여행일정 동행자 */
export type CompanionCGType = {
  __typename?: 'Companion';
  /**  여행일정 동행자 이름 */
  name: Scalars['String']['output'];
};

/**  좌표 입력 타입 */
export type CoordinatesInputCGType = {
  /**  위도 */
  latitude: Scalars['Float']['input'];
  /**  경도 */
  longitude: Scalars['Float']['input'];
};

export type CustomSlotInputCGType = {
  /**  날짜 */
  days?: InputMaybe<Array<InputMaybe<DayInputCGType>>>;
  /**  장소 아이디 */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /**  슬롯 타입 */
  slotType?: InputMaybe<SlotTypeEnumCGType>;
};

/**  날짜 입력 타입 */
export type DayInputCGType = {
  /**  오후 */
  afternoon?: InputMaybe<Scalars['Boolean']['input']>;
  /**  아침 */
  morning?: InputMaybe<Scalars['Boolean']['input']>;
  /**  밤 */
  night?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  삭제된 리뷰 타입 */
export type DeleteReviewCGType = {
  __typename?: 'DeleteReview';
  /**  메시지 */
  message: Scalars['String']['output'];
};

/**  출발 지점 타입 */
export type DeparturePointCGType = {
  __typename?: 'DeparturePoint';
  /**  위도 */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**  위치 */
  location?: Maybe<Scalars['String']['output']>;
  /**  경도 */
  longitude?: Maybe<Scalars['Float']['output']>;
};

/**  출발 지점 입력 타입 */
export type DeparturePointInputCGType = {
  /**  출발 지점 위도 */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /**  출발 지점 경도 */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**  출발 지점 이름 */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DeregistrationLossCGType = {
  __typename?: 'DeregistrationLoss';
  /**  여행일정 카운트 */
  tripCount?: Maybe<Scalars['Int']['output']>;
};

/**  여행일정 경로 */
export type DestinationCGType = {
  __typename?: 'Destination';
  /**  여행일정 경로 숙소 타입 */
  accommType?: Maybe<Scalars['String']['output']>;
  /**  여행일정 경로 날짜 */
  day?: Maybe<Scalars['Int']['output']>;
  /**  여행일정 경로 아이디 */
  id?: Maybe<Scalars['ID']['output']>;
  /**  여행일정 경로 메모 */
  memo?: Maybe<Scalars['String']['output']>;
  /**  여행일정 경로 장소 */
  poi?: Maybe<PoiCGType>;
  /**  여행일정 경로 위치 */
  pos: Scalars['Float']['output'];
  /**  여행일정 경로 슬롯 타입 */
  slotType?: Maybe<SlotTypeEnumCGType>;
  /**  여행일정 경로 타입 */
  type?: Maybe<Scalars['String']['output']>;
};

/**  목적지 입력 타입 */
export type DestinationInputCGType = {
  /**  숙소 타입 */
  accommType?: InputMaybe<Scalars['String']['input']>;
  /**  날짜 */
  day?: InputMaybe<Scalars['Int']['input']>;
  /**  목적지 아이디 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  메모 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /**  장소 아이디 */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /**  위치 */
  pos?: InputMaybe<Scalars['Float']['input']>;
  /**  목적지 타입 */
  type?: InputMaybe<Scalars['String']['input']>;
};

/**  탐색 장소 쿼리 정보 타입 */
export type ExplorePoisQueryInfoCGType = {
  __typename?: 'ExplorePoisQueryInfo';
  /**  제목 */
  title: Scalars['String']['output'];
  /**  존 ID */
  zoneIds: Array<Scalars['ID']['output']>;
};

/**  FTUERecord 타입 */
export type FtueRecordCGType = {
  __typename?: 'FTUERecord';
  /**  코드 */
  code: Scalars['String']['output'];
};

/**  FAQ 타입 */
export type FaqCGType = {
  __typename?: 'Faq';
  /**  FAQ 답변 */
  answer: Scalars['String']['output'];
  /**  FAQ 카테고리 */
  category: Scalars['String']['output'];
  /**  FAQ ID */
  id: Scalars['Int']['output'];
  /**  FAQ 질문 */
  question: Scalars['String']['output'];
};

/**  추천 존 응답 타입 */
export type FeaturedZonesResponseCGType = {
  __typename?: 'FeaturedZonesResponse';
  /**  미국 존 */
  americaZones: Array<ZoneCGType>;
  /**  동아시아 존 */
  eastAsiaZones: Array<ZoneCGType>;
  /**  유럽 존 */
  europeZones: Array<ZoneCGType>;
  /**  일본 존 */
  japanZones: Array<ZoneCGType>;
  /**  한국 존 */
  koreaZones: Array<ZoneCGType>;
  /**  오세아니아 존 */
  oceaniaZones: Array<ZoneCGType>;
  /**  랜덤 존 */
  randomFeaturedZones: Array<ZoneCGType>;
  /**  최근 존 */
  recentZones: Array<ZoneCGType>;
  /**  동남아 존 */
  southeastAsiaZones: Array<ZoneCGType>;
  /**  함께 여행한 존 */
  togetherZones: Array<ZoneCGType>;
};

/**  계정 찾기 요청 결과 타입 */
export type FindAccountRequestResultCGType = {
  __typename?: 'FindAccountRequestResult';
  /**  프로필 ID */
  pid?: Maybe<Scalars['Int']['output']>;
  /**  상태 */
  status: ResponseStatusCGType;
};

/**  공휴일 타입 */
export type HolidayCGType = {
  __typename?: 'Holiday';
  /**  날짜 */
  date: Scalars['Date']['output'];
  /**  이름 */
  name: Scalars['String']['output'];
};

/**  여행일정 사용자 초대 정보 반환 */
export type InviteCoEditInfoCGType = {
  __typename?: 'InviteCoEditInfo';
  /**  여행 도착 도시 */
  arrivalCity?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  여행 출발 도시 */
  departureCity?: Maybe<Scalars['String']['output']>;
  /**  여행 시작 날짜 */
  fromDateTime?: Maybe<Scalars['String']['output']>;
  /**  공동편집 권한 */
  role?: Maybe<CoEditRoleCGType>;
  /**  여행 이름 */
  surveyName?: Maybe<Scalars['String']['output']>;
  /**  여행 종료 날짜 */
  toDateTime?: Maybe<Scalars['String']['output']>;
  /**  여행 아이디 */
  tripId?: Maybe<Scalars['String']['output']>;
  /**  사용자 이름 */
  userName?: Maybe<Scalars['String']['output']>;
};

/**  여행일정 */
export type ItineraryCGType = {
  __typename?: 'Itinerary';
  /**  여행일정 경로 목록 */
  destinations?: Maybe<Array<Maybe<DestinationCGType>>>;
  /**  여행일정 경로 아이디 */
  id: Scalars['ID']['output'];
};

/**  JWT 회원가입 입력 타입 */
export type JwtSignupInputCGType = {
  /**  위치 약관 동의 여부 */
  isLocationTermsAgreed: Scalars['Boolean']['input'];
  /**  닉네임 */
  nickname: Scalars['String']['input'];
  /**  토큰 */
  token: Scalars['String']['input'];
};

export type MainTravelCardCGType = {
  __typename?: 'MainTravelCard';
  title: TravelCardTitleCGType;
  travelCards: Array<TravelCardCGType>;
};

/**  메뉴 타입 */
export type MenuEntryCGType = {
  __typename?: 'MenuEntry';
  /**  메뉴 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /**  메뉴 가격 */
  price?: Maybe<Scalars['String']['output']>;
};

export type MutationCGType = {
  __typename?: 'Mutation';
  /**  여행일정 목적지 추가 쿼리 */
  addDestinations?: Maybe<Array<Maybe<DestinationCGType>>>;
  /**  여행일정 가져오기 쿼리 */
  bringSurvey: SurveyCGType;
  /**  비밀번호 변경 쿼리 */
  changePassword: ResponseStatusCGType;
  /**  여행일정 완료 쿼리 */
  completeTrip: SurveyCGType;
  /**  여행일정 복사 쿼리 */
  copyTrip: SurveyCGType;
  /**  관리자 사용자 생성 쿼리 */
  createAdminUser?: Maybe<AdminUserCGType>;
  /**  여행일정 사용자 초대 링크 생성 쿼리 */
  createInviteCoEditLink?: Maybe<Scalars['String']['output']>;
  /**  장소 생성 쿼리 */
  createPoiByAdmin?: Maybe<PoiCGType>;
  /**  신고 생성 쿼리 */
  createReport: ResponseStatusCGType;
  /**  장소 평가 생성 쿼리 */
  createReview: ReviewCGType;
  /**  여행일정 생성 쿼리 */
  createSurvey?: Maybe<SurveyCGType>;
  /**  여행일정 사용자 생성 쿼리 */
  createSurveyUser?: Maybe<SurveyCGType>;
  /**  여행일정 후기 생성 쿼리 */
  createTravelReview: TravelReviewCGType;
  /**  여행일정 후기 댓글 생성 쿼리 */
  createTravelReviewComment: TravelReviewCommentCGType;
  /**  여행지 등록 요청 쿼리 */
  createZoneRequest: ResponseStatusCGType;
  /**  장소 삭제 쿼리 */
  deletePoiByAdmin: ResponseStatusCGType;
  /**  장소 평가 삭제 쿼리 */
  deleteReview: Scalars['ID']['output'];
  /**  여행일정 삭제 쿼리 */
  deleteSurvey?: Maybe<Scalars['ID']['output']>;
  /**  여행일정 사용자 삭제 쿼리 */
  deleteSurveyUser: ResponseStatusCGType;
  /**  여행일정 후기 삭제 쿼리 */
  deleteTravelReview: ResponseStatusCGType;
  /**  여행일정 후기 댓글 삭제 쿼리 */
  deleteTravelReviewComment: ResponseStatusCGType;
  /**  탈퇴 쿼리 */
  deregister: ResponseStatusCGType;
  /**  장소 평가 무시 쿼리 */
  ignoreUserReview: Scalars['ID']['output'];
  /**  FAQ 조회 수 증가 쿼리 */
  incrementFaqViewCount: ResponseStatusCGType;
  /**  코엑스 프로모션 참여 쿼리 */
  insertCoexPromotion: ResponseStatusCGType;
  /**  여행일정 참여 카운트 증가 쿼리 */
  insertSurveyEntryPoint: ResponseStatusCGType;
  /**  여행일정 날짜 변경 쿼리 */
  modifySurveyDate?: Maybe<SurveyCGType>;
  /**  닉네임 변경 쿼리 */
  modifyfNickname: ResponseStatusCGType;
  /**  월드컵 경기 기록 쿼리 */
  recordWorldcupMatch: ResponseStatusCGType;
  /**  여행일정 목적지 재정렬 쿼리 */
  reorderDestination?: Maybe<Array<Maybe<DestinationCGType>>>;
  /**  장소 평가 신고 쿼리 */
  reportReview: ResponseStatusCGType;
  /**  여행일정 후기 신고 쿼리 */
  reportTravelReview: ResponseStatusCGType;
  /**  여행일정 후기 댓글 신고 쿼리 */
  reportTravelReviewComment: ResponseStatusCGType;
  /**  사용자 신고 쿼리 */
  reportUser: ResponseStatusCGType;
  /**  아이디 찾기 요청 쿼리 */
  requestFindId: FindAccountRequestResultCGType;
  /**  비밀번호 찾기 요청 쿼리 */
  requestFindPassword: FindAccountRequestResultCGType;
  /**  모바일 인증 요청 쿼리 */
  requestMobileVerification: ResponseStatusCGType;
  /**  비밀번호 재설정 쿼리 */
  resetPassword: ResponseStatusCGType;
  /**  월드컵 경기 기록 쿼리 */
  saveFTUERecord: Array<FtueRecordCGType>;
  /**  여행일정 메모 저장 쿼리 */
  saveNote?: Maybe<NoteCGType>;
  /**  여행일정 열기 쿼리 */
  setItineraryOpened: ResponseStatusCGType;
  /**  위치 이용 동의 쿼리 */
  setLocationTermsAgreed: ResponseStatusCGType;
  /**  관리자 사용자 로그인 쿼리 */
  signinAdmin?: Maybe<SigninAdminResultCGType>;
  /**  로그인 쿼리 (zzim token 사용) */
  signinWithZzimToken: SigninResultCGType;
  /**  월드컵 시작 쿼리 */
  startWorldcup: Scalars['ID']['output'];
  /**  장소 차단 토글 쿼리 */
  togglePoiBan?: Maybe<PoiCGType>;
  /**  장소 저장 토글 쿼리 */
  togglePoiSave?: Maybe<PoiCGType>;
  /**  관리자 사용자 승인 상태 업데이트 쿼리 */
  updateAdminUserApprovalStatus: ResponseStatusCGType;
  /**
   *  admin page
   *  장소 업데이트 쿼리
   */
  updatePoiByAdmin?: Maybe<PoiCGType>;
  /**  장소 평가 업데이트 쿼리 */
  updateReview: ReviewCGType;
  /**  여행일정 업데이트 쿼리 */
  updateSurvey?: Maybe<Array<Maybe<DestinationCGType>>>;
  /**  여행일정 사용자 정의 이름 업데이트 쿼리 */
  updateSurveyCustomName: SurveyCGType;
  /**  여행일정 사용자 업데이트 쿼리 */
  updateSurveyUser: ResponseStatusCGType;
  /**  여행일정 후기 업데이트 쿼리 */
  updateTravelReview: TravelReviewCGType;
  /**  여행일정 후기 댓글 업데이트 쿼리 */
  updateTravelReviewComment: TravelReviewCommentCGType;
  /**  사용자 업데이트 쿼리 */
  updateUserByAdmin?: Maybe<UserCGType>;
  /**  여행일정 사용자 초대 링크 유효성 검사 쿼리 -> 유효성 통과 후 여행일정 사용자 초대 정보 반환 */
  validInviteCoEditLink?: Maybe<InviteCoEditInfoCGType>;
};

export type MutationAddDestinationsArgsCGType = {
  destinationInputs: Array<DestinationInputCGType>;
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  increasingCount: Scalars['Int']['input'];
  pos: Scalars['Float']['input'];
  surveyId: Scalars['ID']['input'];
};

export type MutationBringSurveyArgsCGType = {
  guestUuid: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationChangePasswordArgsCGType = {
  newPassword: Scalars['String']['input'];
  passwordToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCompleteTripArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Boolean']['input'];
  surveyId: Scalars['ID']['input'];
};

export type MutationCopyTripArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};

export type MutationCreateAdminUserArgsCGType = {
  adminUserInput?: InputMaybe<AdminUserInputCGType>;
};

export type MutationCreateInviteCoEditLinkArgsCGType = {
  role: CoEditRoleCGType;
  surveyId: Scalars['ID']['input'];
};

export type MutationCreatePoiByAdminArgsCGType = {
  poiWithPropsInput: PoiWithPropsInputCGType;
};

export type MutationCreateReportArgsCGType = {
  reportInput: ReportInputCGType;
};

export type MutationCreateReviewArgsCGType = {
  input?: InputMaybe<ReviewInputCGType>;
  poiId: Scalars['ID']['input'];
};

export type MutationCreateSurveyArgsCGType = {
  input?: InputMaybe<SurveyInputCGType>;
};

export type MutationCreateSurveyUserArgsCGType = {
  inviteId: Scalars['ID']['input'];
};

export type MutationCreateTravelReviewArgsCGType = {
  input?: InputMaybe<TravelReviewInputCGType>;
};

export type MutationCreateTravelReviewCommentArgsCGType = {
  input?: InputMaybe<TravelReviewCommentInputCGType>;
};

export type MutationCreateZoneRequestArgsCGType = {
  zoneRequestInput: ZoneRequestInputCGType;
};

export type MutationDeletePoiByAdminArgsCGType = {
  poiId: Scalars['Int']['input'];
};

export type MutationDeleteReviewArgsCGType = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSurveyArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationDeleteSurveyUserArgsCGType = {
  surveyId: Scalars['ID']['input'];
  surveyUserId: Scalars['ID']['input'];
};

export type MutationDeleteTravelReviewArgsCGType = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteTravelReviewCommentArgsCGType = {
  id: Scalars['Int']['input'];
};

export type MutationIgnoreUserReviewArgsCGType = {
  userId: Scalars['ID']['input'];
};

export type MutationIncrementFaqViewCountArgsCGType = {
  id: Scalars['Int']['input'];
};

export type MutationInsertCoexPromotionArgsCGType = {
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type MutationInsertSurveyEntryPointArgsCGType = {
  entryPoint: Scalars['String']['input'];
};

export type MutationModifySurveyDateArgsCGType = {
  fromDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
  toDateTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MutationModifyfNicknameArgsCGType = {
  nickname: Scalars['String']['input'];
};

export type MutationRecordWorldcupMatchArgsCGType = {
  input: WorldcupMatchInputCGType;
};

export type MutationReorderDestinationArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  reorderDestinationInput: ReorderDestinationInputCGType;
  surveyId: Scalars['ID']['input'];
};

export type MutationReportReviewArgsCGType = {
  reason?: InputMaybe<Scalars['String']['input']>;
  reviewId: Scalars['ID']['input'];
};

export type MutationReportTravelReviewArgsCGType = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationReportTravelReviewCommentArgsCGType = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  travelReviewId: Scalars['Int']['input'];
};

export type MutationReportUserArgsCGType = {
  userId: Scalars['ID']['input'];
};

export type MutationRequestFindIdArgsCGType = {
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type MutationRequestFindPasswordArgsCGType = {
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MutationRequestMobileVerificationArgsCGType = {
  mobile: Scalars['String']['input'];
};

export type MutationResetPasswordArgsCGType = {
  code: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  pid: Scalars['String']['input'];
};

export type MutationSaveFtueRecordArgsCGType = {
  code: Scalars['String']['input'];
};

export type MutationSaveNoteArgsCGType = {
  content?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};

export type MutationSetItineraryOpenedArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};

export type MutationSetLocationTermsAgreedArgsCGType = {
  isAgreed: Scalars['Boolean']['input'];
};

export type MutationSigninAdminArgsCGType = {
  adminUserInput?: InputMaybe<AdminUserInputCGType>;
};

export type MutationSigninWithZzimTokenArgsCGType = {
  accessToken: Scalars['String']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type MutationStartWorldcupArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationTogglePoiBanArgsCGType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationTogglePoiSaveArgsCGType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAdminUserApprovalStatusArgsCGType = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdatePoiByAdminArgsCGType = {
  poiId: Scalars['Int']['input'];
  poiInput: PoiInputCGType;
};

export type MutationUpdateReviewArgsCGType = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ReviewInputCGType>;
};

export type MutationUpdateSurveyArgsCGType = {
  destinationInputs?: InputMaybe<Array<InputMaybe<DestinationInputCGType>>>;
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationUpdateSurveyCustomNameArgsCGType = {
  customName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationUpdateSurveyUserArgsCGType = {
  role: CoEditRoleCGType;
  surveyId: Scalars['ID']['input'];
  surveyUserId: Scalars['ID']['input'];
};

export type MutationUpdateTravelReviewArgsCGType = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<TravelReviewInputCGType>;
};

export type MutationUpdateTravelReviewCommentArgsCGType = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<TravelReviewCommentInputCGType>;
};

export type MutationUpdateUserByAdminArgsCGType = {
  userId: Scalars['ID']['input'];
  userInfo?: InputMaybe<UpdateUserInfoCGType>;
};

export type MutationValidInviteCoEditLinkArgsCGType = {
  inviteId: Scalars['ID']['input'];
};

/**  노트 타입 */
export type NoteCGType = {
  __typename?: 'Note';
  /**  노트 내용 */
  content: Scalars['String']['output'];
};

/**  페이지 정보 타입 */
export type PageInfoCGType = {
  __typename?: 'PageInfo';
  /**  마지막 ID */
  endCursorId?: Maybe<Scalars['ID']['output']>;
  /**  다음 페이지 여부 */
  hasNextPage: Scalars['Boolean']['output'];
  /**  제한 */
  limit?: Maybe<Scalars['Int']['output']>;
  /**  오프셋 */
  offset?: Maybe<Scalars['Int']['output']>;
};

/**  장소 타입 */
export type PoiCGType = {
  __typename?: 'Poi';
  /**  장소 주소 */
  address?: Maybe<Scalars['String']['output']>;
  /**  편의시설 */
  amenities?: Maybe<Array<Maybe<AmenityCGType>>>;
  /**  기사 */
  articles?: Maybe<Array<Maybe<ArticleCGType>>>;
  /**  차단 여부 */
  banned: Scalars['Boolean']['output'];
  /**  영업 상태 */
  businessStatus?: Maybe<BusinessStatusCGType>;
  /**  카테고리 */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  장소 도시 */
  city: CityCGType;
  /**  장소 이메일 */
  email?: Maybe<Scalars['String']['output']>;
  /**  GPT 설명 */
  gptDescription?: Maybe<Scalars['String']['output']>;
  /**  등급 */
  grade?: Maybe<Scalars['Int']['output']>;
  /**  장소 아이디 */
  id: Scalars['ID']['output'];
  /**  이미지 */
  images?: Maybe<Array<Maybe<PoiImageCGType>>>;
  /**  카카오 URL */
  kakaoUrl?: Maybe<Scalars['String']['output']>;
  /**  장소 위도 */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**  장소 경도 */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  장소 메인 이미지 URL */
  mainImageUrl?: Maybe<Scalars['String']['output']>;
  /**  메인 태그 */
  mainTag?: Maybe<Scalars['String']['output']>;
  /**  메뉴 */
  menu?: Maybe<Array<Maybe<MenuEntryCGType>>>;
  /**  미쉐린 랭킹 */
  michelinRating?: Maybe<Scalars['String']['output']>;
  /**  장소 이름 */
  name: Scalars['String']['output'];
  /**  네이버 URL */
  naverUrl?: Maybe<Scalars['String']['output']>;
  /**  오픈 시간 */
  openHours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  해당 요일의 영업 시간 */
  operatingHour?: Maybe<Scalars['String']['output']>;
  /**  장소 원본 이름 */
  originName?: Maybe<Scalars['String']['output']>;
  /**  장소 전화번호 */
  phone?: Maybe<Scalars['String']['output']>;
  /**  장소 아이디 */
  placeId: Scalars['String']['output'];
  /**  장소 타입 */
  poiType: Scalars['String']['output'];
  /**  가격 레벨 */
  priceLevel?: Maybe<Scalars['Int']['output']>;
  /**  가격 범위 */
  priceRange?: Maybe<Scalars['Int']['output']>;
  /**  장소 랭킹 */
  ranking?: Maybe<RankingCGType>;
  /**  평가 */
  ratings?: Maybe<Array<Maybe<RatingCGType>>>;
  /**  예약 URL */
  reservationUrl?: Maybe<Scalars['String']['output']>;
  /**  저장 여부 */
  saved: Scalars['Boolean']['output'];
  /**  소스 */
  source?: Maybe<Scalars['String']['output']>;
  /**  소요 시간 */
  spentTime?: Maybe<Scalars['Float']['output']>;
  /**  태그 */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  트립어드바이저 URL */
  tripadvisorUrl?: Maybe<Scalars['String']['output']>;
  /**  장소 웹사이트 URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/**  장소 연결 타입 */
export type PoiConnectionCGType = {
  __typename?: 'PoiConnection';
  /**  엣지 */
  edges: Array<PoiEdgeCGType>;
  /**  탐색 장소 쿼리 정보 */
  explorePoisQueryInfo?: Maybe<ExplorePoisQueryInfoCGType>;
  /**  페이지 정보 */
  pageInfo: PageInfoCGType;
};

/**  장소 큐레이션 타입 */
export type PoiCurationCGType = {
  __typename?: 'PoiCuration';
  /**  장소 */
  pois: Array<PoiCGType>;
  /**  제목 */
  title: Scalars['String']['output'];
};

/**  장소 엣지 타입 */
export type PoiEdgeCGType = {
  __typename?: 'PoiEdge';
  /**  커서 ID */
  cursorId: Scalars['ID']['output'];
  /**  장소 */
  node: PoiCGType;
};

/**  장소 이미지 타입 */
export type PoiImageCGType = {
  __typename?: 'PoiImage';
  /**  이미지 URL */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /**  원본 출처 URL */
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

/**  장소 이미지 타입 */
export type PoiImageImageUrlArgsCGType = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**  장소 입력 타입 */
export type PoiInputCGType = {
  /**  장소 주소 */
  address?: InputMaybe<Scalars['String']['input']>;
  /**  도시 아이디 */
  cityId?: InputMaybe<Scalars['Int']['input']>;
  /**  상세 */
  detail?: InputMaybe<Scalars['String']['input']>;
  /**  장소 이메일 */
  email?: InputMaybe<Scalars['String']['input']>;
  /**  구글 장소 아이디 */
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  /**  GPT 설명 */
  gptDescription?: InputMaybe<Scalars['String']['input']>;
  /**  등급 */
  grade?: InputMaybe<Scalars['Int']['input']>;
  /**  랜드마크 여부 */
  isLandmark?: InputMaybe<Scalars['Boolean']['input']>;
  /**  카카오 URL */
  kakaoUrl?: InputMaybe<Scalars['String']['input']>;
  /**  장소 위도 */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /**  장소 경도 */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /**  장소 메인 이미지 URL */
  mainImageUrl?: InputMaybe<Scalars['String']['input']>;
  /**  장소 이름 */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  네이버 URL */
  naverUrl?: InputMaybe<Scalars['String']['input']>;
  /**  장소 전화번호 */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**  장소 타입 아이디 */
  poiTypeId?: InputMaybe<Scalars['Int']['input']>;
  /**  랭킹 */
  ranking?: InputMaybe<Scalars['String']['input']>;
  /**  예약 URL */
  reservationUrl?: InputMaybe<Scalars['String']['input']>;
  /**  소스 */
  source?: InputMaybe<Scalars['String']['input']>;
  /**  장소 시간대 */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /**  트립어드바이저 위치 아이디 */
  tripadvisorLocationId?: InputMaybe<Scalars['String']['input']>;
  /**  트립어드바이저 URL */
  tripadvisorUrl?: InputMaybe<Scalars['String']['input']>;
  /**  장소 웹사이트 URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/**  장소 속성 입력 타입 */
export type PoiPropsInputCGType = {
  /**  숙소 스타일 */
  accommStyles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  편의시설 */
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  혼자 가도 되는지 여부 */
  goodForAlone?: InputMaybe<Scalars['Boolean']['input']>;
  /**  커플 좋은지 여부 */
  goodForCouples?: InputMaybe<Scalars['Boolean']['input']>;
  /**  가족 좋은지 여부 */
  goodForFamily?: InputMaybe<Scalars['Boolean']['input']>;
  /**  무료 입장 좋은지 여부 */
  goodForFreeEntry?: InputMaybe<Scalars['Boolean']['input']>;
  /**  친구 좋은지 여부 */
  goodForFriends?: InputMaybe<Scalars['Boolean']['input']>;
  /**  숨겨진 보석 좋은지 여부 */
  goodForHiddenGem?: InputMaybe<Scalars['Boolean']['input']>;
  /**  아이들 좋은지 여부 */
  goodForKids?: InputMaybe<Scalars['Boolean']['input']>;
  /**  비가 오는 날 좋은지 여부 */
  goodForRainyDay?: InputMaybe<Scalars['Boolean']['input']>;
  /**  경관 좋은지 여부 */
  goodForScenicView?: InputMaybe<Scalars['Boolean']['input']>;
  /**  구글 카테고리 */
  googleCategory?: InputMaybe<Scalars['String']['input']>;
  /**  구글 사진 카운트 */
  googlePhotoCount?: InputMaybe<Scalars['Int']['input']>;
  /**  구글 평점 */
  googleRating?: InputMaybe<Scalars['Float']['input']>;
  /**  구글 리뷰 카운트 */
  googleRatingCount?: InputMaybe<Scalars['Int']['input']>;
  /**  영업 시간 */
  hours?: InputMaybe<Scalars['String']['input']>;
  /**  영업 시간 추가 */
  hoursExtra?: InputMaybe<Scalars['String']['input']>;
  /**  혼자 가도 되는지 여부 */
  isAloneOkay?: InputMaybe<Scalars['Boolean']['input']>;
  /**  브런치 가능 여부 */
  isBrunchOkay?: InputMaybe<Scalars['Boolean']['input']>;
  /**  가을 좋은지 여부 */
  isFallGood?: InputMaybe<Scalars['Boolean']['input']>;
  /**  주차 가능 여부 */
  isParkingOkay?: InputMaybe<Scalars['Boolean']['input']>;
  /**  봄 좋은지 여부 */
  isSpringGood?: InputMaybe<Scalars['Boolean']['input']>;
  /**  여름 좋은지 여부 */
  isSummerGood?: InputMaybe<Scalars['Boolean']['input']>;
  /**  대중교통 가능 여부 */
  isTransitOkay?: InputMaybe<Scalars['Boolean']['input']>;
  /**  비건 가능 여부 */
  isVegeOkay?: InputMaybe<Scalars['Boolean']['input']>;
  /**  겨울 좋은지 여부 */
  isWinterGood?: InputMaybe<Scalars['Boolean']['input']>;
  /**  카카오 평점 */
  kakaoRating?: InputMaybe<Scalars['Float']['input']>;
  /**  카카오 리뷰 카운트 */
  kakaoRatingCount?: InputMaybe<Scalars['Int']['input']>;
  /**  메뉴 */
  menu?: InputMaybe<Scalars['String']['input']>;
  /**  네이버 카테고리 */
  naverCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  네이버 아이들 카운트 */
  naverKidsCount?: InputMaybe<Scalars['Int']['input']>;
  /**  네이버 리뷰 카운트 */
  naverNumReviews?: InputMaybe<Scalars['Int']['input']>;
  /**  네이버 평점 */
  naverRating?: InputMaybe<Scalars['Float']['input']>;
  /**  어른만 가능 여부 */
  onlyForAdults?: InputMaybe<Scalars['Boolean']['input']>;
  /**  가격 레벨 */
  priceLevel?: InputMaybe<Scalars['Int']['input']>;
  /**  가격 범위 */
  priceRange?: InputMaybe<Scalars['Int']['input']>;
  /**  소요 시간 */
  spentTime?: InputMaybe<Scalars['Float']['input']>;
  /**  트립어드바이저 카테고리 */
  tripadvisorCategories?: InputMaybe<Scalars['String']['input']>;
  /**  트립어드바이저 커플 카운트 */
  tripadvisorCouplesCount?: InputMaybe<Scalars['Int']['input']>;
  /**  트립어드바이저 가족 카운트 */
  tripadvisorFamilyCount?: InputMaybe<Scalars['Int']['input']>;
  /**  트립어드바이저 친구 카운트 */
  tripadvisorFriendsCount?: InputMaybe<Scalars['Int']['input']>;
  /**  트립어드바이저 리뷰 카운트 */
  tripadvisorNumReviews?: InputMaybe<Scalars['Int']['input']>;
  /**  트립어드바이저 사진 카운트 */
  tripadvisorPhotoCount?: InputMaybe<Scalars['Int']['input']>;
  /**  트립어드바이저 평점 */
  tripadvisorRating?: InputMaybe<Scalars['Float']['input']>;
  /**  트립어드바이저 솔로 카운트 */
  tripadvisorSoloCount?: InputMaybe<Scalars['Int']['input']>;
};

/**  장소 속성 입력 타입d */
export type PoiWithPropsInputCGType = {
  /**  장소 입력 */
  poiInput: PoiInputCGType;
  /**  장소 속성 입력 */
  poiPropsInput: PoiPropsInputCGType;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryCGType = {
  __typename?: 'Query';
  /**  모든 저장된 장소를 불러오는 쿼리 */
  allSavedPois: Array<PoiCGType>;
  /**  도시 목록 조회 쿼리 */
  cities: Array<CityCGType>;
  /**  장소를 검색 결과로 변환하는 쿼리 */
  convertSearchResultFromPoi?: Maybe<SearchResultCGType>;
  /**  출발지 장소 목록을 불러오는 쿼리 */
  departurePois: Array<SearchResultCGType>;
  /**  중복된 장소 목록을 불러오는 쿼리 */
  duplicatePoisByAdmin?: Maybe<Array<Maybe<PoiCGType>>>;
  /**  SSO 요청을 암호화하는 쿼리 */
  encryptSsoRequest: EncryptSsoRequestResultCGType;
  /**  장소를 검색 결과로 변환하는 쿼리 */
  explorePois: PoiConnectionCGType;
  /**  FAQ 목록을 불러오는 쿼리 */
  faqs: Array<FaqCGType>;
  /**  추천 영역 목록 조회 쿼리 */
  featuredZones: FeaturedZonesResponseCGType;
  /**  여행일정 후기의 댓글을 불러오는 쿼리 */
  getCommentsByTravelReviewId: Array<TravelReviewCommentCGType>;
  /**  여행지 카드 상세 조회 쿼리 */
  getTravelCard: TravelCardCGType;
  getTravelCardCategory: Array<Scalars['String']['output']>;
  /**  여행지 카드 poi 상세 조회 쿼리 */
  getTravelCardPoi: TravelCardPoiCGType;
  /**  여행일정 후기를 불러오는 쿼리 */
  getTravelReview: TravelReviewResultCGType;
  /**  휴일 목록을 불러오는 쿼리 */
  holidays: Array<HolidayCGType>;
  /**  마지막으로 생성된 여행일정을 불러오는 쿼리 */
  lastCreatedSurvey?: Maybe<SurveyCGType>;
  /**  모든 사용자 목록을 불러오는 쿼리 */
  listAllUsersByAdmin?: Maybe<Array<Maybe<UserCGType>>>;
  /**  여행일정 참여자 목록을 불러오는 쿼리 */
  listCoEditSurveyByAdmin?: Maybe<Array<Maybe<SurveyCGType>>>;
  /**  큐레이션된 여행일정 목록을 불러오는 쿼리 */
  listCurateSurveyByAdmin?: Maybe<Array<Maybe<SurveyCGType>>>;
  /**  FAQ 목록을 불러오는 쿼리 */
  listFaqsByAdmin?: Maybe<Array<Maybe<FaqCGType>>>;
  listMainTravelCards?: Maybe<MainTravelCardCGType>;
  /**  승인 대기 사용자 목록을 불러오는 쿼리 */
  listPendingApprovalUsers?: Maybe<Array<Maybe<AdminUserCGType>>>;
  /**  신고 목록을 불러오는 쿼리 */
  listReportsByAdmin?: Maybe<Array<Maybe<ReportCGType>>>;
  /**  여행일정 참여자 목록을 불러오는 쿼리 */
  listSurveyUsers?: Maybe<Array<Maybe<CoEditUserCGType>>>;
  /**  여행일정 참여자 목록을 불러오는 쿼리 */
  listSurveyUsersByAdmin?: Maybe<Array<Maybe<CoEditUserCGType>>>;
  /**  여행지 카드 poi 목록을 불러오는 쿼리 */
  listTravelCardPoi?: Maybe<Array<Maybe<TravelCardPoiCGType>>>;
  /** 여행지 카드 목록을 불러오는 쿼리 */
  listTravelCards: Array<TravelCardCGType>;
  /**  여행일정 후기 목록을 불러오는 쿼리 */
  listTravelReview?: Maybe<TravelReviewConnectionCGType>;
  /**  탈퇴 손실 데이터를 불러오는 쿼리 */
  lossOnDeregistration: DeregistrationLossCGType;
  /**
   *  coords: [[Float]] = [[fromLat, fromLng, toLat, toLng], ...]
   *  사용자 조회 쿼리
   */
  me: UserCGType;
  /**  여행일정 메모를 불러오는 쿼리 */
  note?: Maybe<NoteCGType>;
  /**  사용자가 소유한 여행일정 목록 조회 쿼리 */
  ownSurveys: SurveyConnectionCGType;
  /**  장소 조회 쿼리 */
  poi?: Maybe<PoiCGType>;
  /**  장소 조회 쿼리 */
  poiByPlaceId?: Maybe<PoiCGType>;
  /**  장소를 검색 결과로 변환하는 쿼리 */
  poiCurations: Array<PoiCurationCGType>;
  /**
   *  For main pages
   *  마지막으로 열린 여행일정을 불러오는 쿼리
   */
  recentlyOpenedSurveys: Array<SurveyCGType>;
  /**  장소 평가 목록 조회 쿼리 */
  reviews?: Maybe<ReviewResponseCGType>;
  /**  저장된 장소 목록 조회 쿼리 */
  savedPois: PoiConnectionCGType;
  /**  선택된 영역의 저장된 장소 목록 조회 쿼리 */
  savedPoisBySelectedZoneIds: SearchResultConnectionCGType;
  /**  도시 검색 쿼리 */
  searchCityByAdmin?: Maybe<Array<Maybe<CityCGType>>>;
  /**  장소 검색 쿼리 */
  searchPoi?: Maybe<Array<Maybe<SearchResultCGType>>>;
  /**  장소 검색 쿼리 V2 */
  searchPoiV2?: Maybe<Array<Maybe<SearchResultCGType>>>;
  /**
   *  admin page
   *  장소 검색 쿼리
   */
  searchPoisByAdmin?: Maybe<Array<Maybe<PoiCGType>>>;
  /**  저장된 장소 검색 쿼리 */
  searchSavedPois?: Maybe<Array<Maybe<PoiCGType>>>;
  /**  사용자 검색 쿼리 */
  searchUserByAdmin?: Maybe<Array<Maybe<UserCGType>>>;
  /**  영역 검색 쿼리 */
  searchZones: Array<Maybe<ZoneCGType>>;
  /**  여행일정 조회 쿼리 */
  survey?: Maybe<SurveyCGType>;
  /**  여행일정 목록 조회 쿼리 */
  surveys?: Maybe<Array<Maybe<SurveyCGType>>>;
  /**  교통 정보 조회 쿼리 */
  transports?: Maybe<Array<Maybe<TransportResponseCGType>>>;
  /**  여행일정 큐레이션 목록을 불러오는 쿼리 */
  tripCurations: Array<TripCurationCGType>;
  upcomingSurveysByPoi: SurveyConnectionCGType;
  /**  월드컵 영역 목록 조회 쿼리 */
  worldcupZones: Array<ZoneCGType>;
  /**  여행 일정에 맞는 찜카 상품 목록을 불러오는 쿼리 */
  zzimProductList?: Maybe<Array<Maybe<ZzimProductInfoCGType>>>;
  zzimProductListMo?: Maybe<Array<Maybe<ZzimProductInfoCGType>>>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryCitiesArgsCGType = {
  ids: Array<Scalars['ID']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryConvertSearchResultFromPoiArgsCGType = {
  poiId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryDeparturePoisArgsCGType = {
  center?: InputMaybe<CoordinatesInputCGType>;
  destinationZoneIDs: Array<Scalars['ID']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryEncryptSsoRequestArgsCGType = {
  redirectUrl: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryExplorePoisArgsCGType = {
  after?: InputMaybe<Scalars['ID']['input']>;
  companionName?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  zoneIds: Array<Scalars['ID']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryFeaturedZonesArgsCGType = {
  selectedZoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryGetCommentsByTravelReviewIdArgsCGType = {
  travelReviewId: Scalars['Int']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryGetTravelCardArgsCGType = {
  id: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryGetTravelCardPoiArgsCGType = {
  id: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryGetTravelReviewArgsCGType = {
  id: Scalars['Int']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryHolidaysArgsCGType = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryListReportsByAdminArgsCGType = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryListSurveyUsersArgsCGType = {
  surveyId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryListSurveyUsersByAdminArgsCGType = {
  surveyId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryListTravelCardPoiArgsCGType = {
  travelCardId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryListTravelReviewArgsCGType = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryNoteArgsCGType = {
  surveyId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryOwnSurveysArgsCGType = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryPoiArgsCGType = {
  id: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryPoiByPlaceIdArgsCGType = {
  placeId: Scalars['String']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryReviewsArgsCGType = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  poiId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySavedPoisArgsCGType = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySavedPoisBySelectedZoneIdsArgsCGType = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  selectedZoneIds: Array<Scalars['ID']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchCityByAdminArgsCGType = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchPoiArgsCGType = {
  center?: InputMaybe<CoordinatesInputCGType>;
  includePolitical?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchPoiV2ArgsCGType = {
  center?: InputMaybe<CoordinatesInputCGType>;
  includePolitical?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchPoisByAdminArgsCGType = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchSavedPoisArgsCGType = {
  center?: InputMaybe<CoordinatesInputCGType>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchUserByAdminArgsCGType = {
  searchUserInput?: InputMaybe<SearchUserInputCGType>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySearchZonesArgsCGType = {
  query: Scalars['String']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QuerySurveyArgsCGType = {
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryTransportsArgsCGType = {
  coords?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryUpcomingSurveysByPoiArgsCGType = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  poiId: Scalars['ID']['input'];
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryZzimProductListArgsCGType = {
  surveyId: Scalars['ID']['input'];
  zzimProductInput?: InputMaybe<ZzimProductInputCGType>;
};

/**  String in the form of "2023-02-21T12:34:56.789Z" */
export type QueryZzimProductListMoArgsCGType = {
  surveyId: Scalars['ID']['input'];
  zzimProductInput?: InputMaybe<ZzimProductInputCGType>;
};

/**  랭킹 타입 */
export type RankingCGType = {
  __typename?: 'Ranking';
  /**  생성 날짜 */
  createdAt: Scalars['Date']['output'];
  /**  랭킹 텍스트 */
  text?: Maybe<Scalars['String']['output']>;
};

/**  평점 타입 */
export type RatingCGType = {
  __typename?: 'Rating';
  /**  평점 카운트 */
  count?: Maybe<Scalars['Int']['output']>;
  /**  평점 제공자 */
  provider?: Maybe<Scalars['String']['output']>;
  /**  평점 */
  rating?: Maybe<Scalars['String']['output']>;
  /**  평점 URL */
  url?: Maybe<Scalars['String']['output']>;
};

/**  재정렬 방향 */
export enum ReorderDestinationDirectionCGType {
  DownCGType = 'DOWN',
  UpCGType = 'UP',
}

/**  재정렬 입력 타입 */
export type ReorderDestinationInputCGType = {
  /**  날짜 */
  day: Scalars['Int']['input'];
  /**  방향 */
  direction?: InputMaybe<ReorderDestinationDirectionCGType>;
  /**  ID */
  id: Scalars['ID']['input'];
  /**  위치 */
  pos: Scalars['Float']['input'];
};

/**  신고 타입 */
export type ReportCGType = {
  __typename?: 'Report';
  /**  신고 내용 */
  content: Scalars['String']['output'];
  /**  생성일 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**  이메일 */
  email: Scalars['String']['output'];
  /**  게스트 UUID */
  guestUuid?: Maybe<Scalars['String']['output']>;
  /**  신고 ID */
  id?: Maybe<Scalars['ID']['output']>;
  /**  전화번호 */
  phone?: Maybe<Scalars['String']['output']>;
  /**  상태 */
  status?: Maybe<Scalars['String']['output']>;
  /**  업데이트 일 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  사용자 */
  user?: Maybe<UserCGType>;
};

/**  신고 입력 타입 */
export type ReportInputCGType = {
  /**  내용 */
  content: Scalars['String']['input'];
  /**  이메일 */
  email: Scalars['String']['input'];
  /**  게스트 UUID */
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  /**  전화번호 */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**  응답 상태 */
export enum ResponseStatusCGType {
  DuplicatedCGType = 'Duplicated',
  ExpiredCGType = 'Expired',
  FailedCGType = 'Failed',
  NonexistentCGType = 'Nonexistent',
  OkCGType = 'OK',
  UnauthorizedCGType = 'Unauthorized',
}

/**  리뷰 타입 */
export type ReviewCGType = {
  __typename?: 'Review';
  /**  작성자 이름 */
  authorName?: Maybe<Scalars['String']['output']>;
  /**  작성자 URL */
  authorUrl?: Maybe<Scalars['String']['output']>;
  /**  작성일 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**  하이라이트 칩 */
  highlightChips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  리뷰 ID */
  id?: Maybe<Scalars['ID']['output']>;
  /**  좋아요 여부 */
  isLiked?: Maybe<Scalars['Boolean']['output']>;
  /**  장소 */
  poi?: Maybe<PoiCGType>;
  /**  가격 범위 */
  priceRange?: Maybe<Scalars['String']['output']>;
  /**  프로필 이미지 URL */
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  /**  제공자 */
  provider?: Maybe<Scalars['String']['output']>;
  /**  평점 */
  rating?: Maybe<Scalars['String']['output']>;
  /**  소요 시간 범위 */
  spentTimeRange?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /**  리뷰 내용 */
  text?: Maybe<Scalars['String']['output']>;
  /**  제목 */
  title?: Maybe<Scalars['String']['output']>;
  /**  여행 유형 */
  tripType?: Maybe<Scalars['String']['output']>;
  /**  업데이트 일 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  사용자 ID */
  userId?: Maybe<Scalars['ID']['output']>;
  /**  사용자 이름 */
  userName?: Maybe<Scalars['String']['output']>;
  /**  사용자 닉네임 */
  userNickname?: Maybe<Scalars['String']['output']>;
};

/**  리뷰 입력 타입 */
export type ReviewInputCGType = {
  /**  하이라이트 칩 */
  highlightChips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  좋아요 여부 */
  isLiked?: InputMaybe<Scalars['Boolean']['input']>;
  /**  가격 범위 */
  priceRange?: InputMaybe<Scalars['String']['input']>;
  /**  소요 시간 범위 */
  spentTimeRange?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /**  리뷰 내용 */
  text?: InputMaybe<Scalars['String']['input']>;
};

/**  리뷰 응답 타입 */
export type ReviewResponseCGType = {
  __typename?: 'ReviewResponse';
  /**  마지막 ID */
  endId?: Maybe<Scalars['ID']['output']>;
  /**  다음 페이지 여부 */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /**  리뷰 */
  reviews?: Maybe<Array<Maybe<ReviewCGType>>>;
};

/**  장소 검색 결과 반환 */
export type SearchResultCGType = {
  __typename?: 'SearchResult';
  /**  장소 주소 */
  address?: Maybe<Scalars['String']['output']>;
  /**  장소 도시 */
  city?: Maybe<CityCGType>;
  /**  장소 위도 */
  latitude?: Maybe<Scalars['Float']['output']>;
  /**  장소 경도 */
  longitude?: Maybe<Scalars['Float']['output']>;
  /**  장소 메인 이미지 URL */
  mainImageUrl?: Maybe<Scalars['String']['output']>;
  /**  장소 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /**  장소 아이디 */
  placeId?: Maybe<Scalars['String']['output']>;
  /**  장소 */
  poi?: Maybe<PoiCGType>;
  /**  장소 타입 */
  poiType?: Maybe<Scalars['String']['output']>;
  /**  장소 주소 */
  redactedAddress?: Maybe<Scalars['String']['output']>;
  /**  장소 영역 */
  zones?: Maybe<Array<Maybe<ZoneCGType>>>;
};

/**  장소 검색 결과 반환 */
export type SearchResultMainImageUrlArgsCGType = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/**  검색 결과 연결 타입 */
export type SearchResultConnectionCGType = {
  __typename?: 'SearchResultConnection';
  /**  엣지 */
  edges: Array<SearchResultEdgeCGType>;
  /**  페이지 정보 */
  pageInfo: PageInfoCGType;
};

/**  검색 결과 엣지 타입 */
export type SearchResultEdgeCGType = {
  __typename?: 'SearchResultEdge';
  /**  커서 ID */
  cursorId: Scalars['ID']['output'];
  /**  검색 결과 */
  node: SearchResultCGType;
};

/**  미사용 */
export type SearchUserInputCGType = {
  /**  검색 입력 */
  input?: InputMaybe<Scalars['String']['input']>;
  /**  검색 옵션 */
  option?: InputMaybe<Scalars['String']['input']>;
};

/**  관리자 로그인 결과 타입 */
export type SigninAdminResultCGType = {
  __typename?: 'SigninAdminResult';
  /**  액세스 토큰 */
  accessToken?: Maybe<Scalars['String']['output']>;
  /**  관리자 사용자 */
  adminUser?: Maybe<AdminUserCGType>;
  /**  상태 */
  status: ResponseStatusCGType;
};

/**  로그인 입력 타입 */
export type SigninInputCGType = {
  /**  비밀번호 */
  password: Scalars['String']['input'];
  /**  사용자 ID */
  userId: Scalars['String']['input'];
};

/**  로그인 결과 타입 */
export type SigninResultCGType = {
  __typename?: 'SigninResult';
  /**  액세스 토큰 */
  accessToken?: Maybe<Scalars['String']['output']>;
  /**  리다이렉트 URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /**  리소스 */
  resource?: Maybe<Scalars['String']['output']>;
  /**  상태 */
  status: ResponseStatusCGType;
  /**  사용자 */
  user?: Maybe<UserCGType>;
  /**  ZZIM 액세스 토큰 */
  zzimAccessToken?: Maybe<Scalars['String']['output']>;
  /**  ZZIM 리프레시 토큰 */
  zzimRefreshToken?: Maybe<Scalars['String']['output']>;
};

/**  회원가입 입력 타입 */
export type SignupInputCGType = {
  /**  생년월일 */
  birth: Scalars['Date']['input'];
  /**  이메일 */
  email: Scalars['String']['input'];
  /**  외부 로그인 유형 */
  externalLoginType?: InputMaybe<Scalars['String']['input']>;
  /**  이름 */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /**  위치 약관 동의 여부 */
  isLocationTermsAgreed: Scalars['Boolean']['input'];
  /**  성 */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**  전화번호 */
  mobile: Scalars['String']['input'];
  /**  이름 */
  name: Scalars['String']['input'];
  /**  비밀번호 */
  password?: InputMaybe<Scalars['String']['input']>;
  /**  사용자 ID */
  userId: Scalars['String']['input'];
};

/**  슬롯 타입 */
export enum SlotTypeEnumCGType {
  AccommCGType = 'Accomm',
  ActivityCGType = 'Activity',
  AttractionCGType = 'Attraction',
  CafeCGType = 'Cafe',
  MemoCGType = 'Memo',
  RestaurantCGType = 'Restaurant',
  ShoppingCGType = 'Shopping',
}

/**  여행일정 타입 */
export type SurveyCGType = {
  __typename?: 'Survey';
  /**  여행일정 자동 완성 여부 */
  autofillAvailable: Scalars['Boolean']['output'];
  /**  여행일정 도시 */
  cities?: Maybe<Array<Maybe<CityCGType>>>;
  /**  여행일정 동행자 */
  companion: CompanionCGType;
  /**  여행일정 생성 날짜 */
  createdAt: Scalars['DateTime']['output'];
  /**  여행일정 이름 */
  customName?: Maybe<Scalars['String']['output']>;
  /**  여행일정 출발 지점 */
  departurePoint?: Maybe<DeparturePointCGType>;
  /**  여행일정 시작 날짜 */
  fromDateTime: Scalars['DateTime']['output'];
  /**  여행일정 아이디 */
  id: Scalars['ID']['output'];
  /**  여행일정 공동편집 여부 */
  isCoEdit?: Maybe<Scalars['String']['output']>;
  /**  여행일정 공동편집 여부 */
  isCoSurvey?: Maybe<Scalars['Boolean']['output']>;
  /**  여행일정 완료 여부 */
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  /**  여행일정 소유 여부 */
  isOwn: Scalars['Boolean']['output'];
  /**  여행일정 경로 */
  itinerary?: Maybe<ItineraryCGType>;
  /**  여행일정 메모 */
  note?: Maybe<NoteCGType>;
  /**  여행일정 상태 */
  status?: Maybe<SurveyStatusCGType>;
  /**  여행일정 종료 날짜 */
  toDateTime: Scalars['DateTime']['output'];
};

/**  여행일정 연결 타입 */
export type SurveyConnectionCGType = {
  __typename?: 'SurveyConnection';
  /**  엣지 */
  edges: Array<SurveyEdgeCGType>;
  /**  페이지 정보 */
  pageInfo: PageInfoCGType;
};

/**  여행일정 엣지 타입 */
export type SurveyEdgeCGType = {
  __typename?: 'SurveyEdge';
  /**  커서 ID */
  cursorId: Scalars['ID']['output'];
  /**  여행일정 */
  node: SurveyCGType;
};

/**  여행일정 입력 타입 */
export type SurveyInputCGType = {
  /**  도시 아이디 */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  /**  여행일정 동행자 */
  companion: Scalars['String']['input'];
  /**  여행일정 이름 */
  customName?: InputMaybe<Scalars['String']['input']>;
  /**  여행일정 슬롯 */
  customSlots?: InputMaybe<Array<InputMaybe<CustomSlotInputCGType>>>;
  /**  여행일정 출발 지점 */
  departurePoint?: InputMaybe<DeparturePointInputCGType>;
  /**  여행일정 시작 날짜 */
  fromDateTime: Scalars['DateTime']['input'];
  /**  게스트 UUID */
  guestUuid?: InputMaybe<Scalars['String']['input']>;
  /**  메인 태그 */
  mainVisible?: InputMaybe<Scalars['String']['input']>;
  /**  여행일정 종료 날짜 */
  toDateTime: Scalars['DateTime']['input'];
  /**  영역 아이디 */
  zoneIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

/**  여행일정 상태 */
export enum SurveyStatusCGType {
  CreatedCGType = 'CREATED',
  CreationInProgressCGType = 'CREATION_IN_PROGRESS',
  FailedCGType = 'FAILED',
  OpenedCGType = 'OPENED',
}

/**  교통 응답 타입 */
export type TransportResponseCGType = {
  __typename?: 'TransportResponse';
  /**  둘 다 한국인지 여부 */
  areBothInKorea?: Maybe<Scalars['Boolean']['output']>;
  /**  좌표 */
  coords?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /**  소요 시간 */
  duration?: Maybe<Scalars['Float']['output']>;
};

/**  여행지 카드 타입 */
export type TravelCardCGType = {
  __typename?: 'TravelCard';
  /**  여행지 대륙 */
  continent?: Maybe<Scalars['String']['output']>;
  /**  여행지 물가 */
  costOfLiving?: Maybe<Scalars['String']['output']>;
  /**  여행지 국가 */
  country: Scalars['String']['output'];
  /**  여행지 카드 생성일 */
  createdAt: Scalars['DateTime']['output'];
  /**  여행지 통화 */
  currency?: Maybe<Scalars['String']['output']>;
  /**  여행지 카드 설명 */
  description: Scalars['String']['output'];
  /**  여행지 통화 환율 */
  exchangeRate?: Maybe<Scalars['String']['output']>;
  /**  여행지 비행 소요 시간 */
  flightTime: Scalars['String']['output'];
  /**  여행지 카드 ID */
  id: Scalars['ID']['output'];
  /**  여행지 직항 여부 */
  isDirectFlight: Scalars['Boolean']['output'];
  /**  여행지 카드 공개 여부 */
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  /**  여행지 카드 메인 이미지 URL */
  mainImageUrl: Scalars['String']['output'];
  /**  여행지 이름 */
  name: Scalars['String']['output'];
  /**  여행지 영어 이름 */
  nameEng: Scalars['String']['output'];
  /**  poi 영역 타이틀 */
  poiTitle?: Maybe<TravelCardPoiTitleCGType>;
  /**  여행 추천 월 */
  recommendMonth?: Maybe<Scalars['String']['output']>;
  /**  여행지 카드 정렬 순서 */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**  여행지 시차 */
  timeDifference: Scalars['String']['output'];
  /**  여행지 카드 수정일 */
  updatedAt: Scalars['DateTime']['output'];
  /**  여행지 카드 조회 수 */
  viewCount?: Maybe<Scalars['Int']['output']>;
  /**  여행지 카드 존 */
  zone: ZoneCGType;
};

export type TravelCardPoiCGType = {
  __typename?: 'TravelCardPoi';
  /**  여행지 카드 poi 주소 */
  address: Scalars['String']['output'];
  /**  여행지 카드 poi 최적 방문 시간 */
  bestVisitTime?: Maybe<Scalars['String']['output']>;
  /**  여행지 카드 poi 생성일 */
  createdAt: Scalars['DateTime']['output'];
  /**  여행지 카드 poi 설명 */
  description: Scalars['String']['output'];
  /**  여행지 카드 poi 입장료 */
  entryFee?: Maybe<Scalars['String']['output']>;
  /**  여행지 카드 poi ID */
  id: Scalars['ID']['output'];
  /**  여행지 카드 poi 이미지 */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  여행지 카드 poi 이름 */
  name: Scalars['String']['output'];
  /**  여행지 카드 poi 운영 시간 */
  operatingHours?: Maybe<Array<Maybe<TravelCardPoiOperatingHourCGType>>>;
  /**  여행지 카드 poi 타입 */
  poiType: Scalars['String']['output'];
  /**  여행지 카드 poi 정렬 순서 */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**  여행지 카드 poi 태그 */
  tags: Array<Scalars['String']['output']>;
  /**  여행지 카드 poi 썸네일 */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /**  여행지 카드 ID */
  travelCardId: Scalars['ID']['output'];
  /**  여행지 카드 poi 수정일 */
  updatedAt: Scalars['DateTime']['output'];
};

export type TravelCardPoiOperatingHourCGType = {
  __typename?: 'TravelCardPoiOperatingHour';
  /**  여행지 카드 poi 운영 시간 키 */
  key: Scalars['String']['output'];
  /**  여행지 카드 poi 운영 시간 값 */
  value: Scalars['String']['output'];
};

export type TravelCardPoiTitleCGType = {
  __typename?: 'TravelCardPoiTitle';
  highlightText: Scalars['String']['output'];
  normalText: Scalars['String']['output'];
};

export type TravelCardTitleCGType = {
  __typename?: 'TravelCardTitle';
  highlightText: Scalars['String']['output'];
  normalText: Scalars['String']['output'];
};

/**  여행일정 후기 타입 */
export type TravelReviewCGType = {
  __typename?: 'TravelReview';
  /**  여행일정 후기 카테고리 */
  category: Scalars['String']['output'];
  /**  여행일정 후기 댓글 */
  comments?: Maybe<Array<Maybe<TravelReviewCommentCGType>>>;
  /**  여행일정 후기 내용 */
  content: Scalars['String']['output'];
  /**  일정표 복사된 횟수 */
  copyCount: Scalars['Int']['output'];
  /**  여행일정 후기 작성일 */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  여행일정 후기 작성자가 여행일정 소유자인지 여부 */
  isOwner: Scalars['Boolean']['output'];
  /**  여행일정 ID */
  surveyId: Scalars['ID']['output'];
  /**  여행일정 후기 제목 */
  title: Scalars['String']['output'];
  /**  여행일정 후기 수정일 */
  updatedAt: Scalars['DateTime']['output'];
  /**  여행일정 후기 작성자 이름 */
  userName: Scalars['String']['output'];
  /**  조회수 */
  viewCount: Scalars['Int']['output'];
};

/**  여행일정 후기 카테고리 */
export enum TravelReviewCategoryEnumCGType {
  AfterTravelCGType = 'AFTER_TRAVEL',
  BeforeTravelCGType = 'BEFORE_TRAVEL',
}

/**  여행일정 후기 댓글 타입 */
export type TravelReviewCommentCGType = {
  __typename?: 'TravelReviewComment';
  children?: Maybe<Array<Maybe<TravelReviewCommentCGType>>>;
  content?: Maybe<Scalars['String']['output']>;
  /**  댓글 작성일 */
  createdAt: Scalars['DateTime']['output'];
  /**  댓글 ID */
  id: Scalars['Int']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /**  댓글 작성자가 여행일정 후기 소유자인지 여부 */
  isOwner: Scalars['Boolean']['output'];
  /**  여행일정 후기 ID */
  travelReviewId: Scalars['Int']['output'];
  /**  댓글 수정일 */
  updatedAt: Scalars['DateTime']['output'];
  userName: Scalars['String']['output'];
};

/**  여행일정 후기 댓글 입력 타입 */
export type TravelReviewCommentInputCGType = {
  /**  댓글 내용 */
  content: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /**  여행일정 후기 ID */
  travelReviewId: Scalars['Int']['input'];
};

/**  여행일정 후기 연결 타입 */
export type TravelReviewConnectionCGType = {
  __typename?: 'TravelReviewConnection';
  /**  엣지 */
  edges: Array<TravelReviewCGType>;
  /**  다음 페이지 여부 */
  hasNext: Scalars['Boolean']['output'];
};

/**  여행일정 후기 입력 타입 */
export type TravelReviewInputCGType = {
  /**  카테고리 */
  category: TravelReviewCategoryEnumCGType;
  /**  내용 */
  content: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  여행일정 ID */
  surveyId: Scalars['ID']['input'];
  /**  제목 */
  title: Scalars['String']['input'];
};

/**  삭제된 데이터일 경우 DeleteReview 반환, 그렇지 않은 경우 TravelReview 반환 */
export type TravelReviewResultCGType = DeleteReviewCGType | TravelReviewCGType;

/**  여행일정 큐레이션 타입 */
export type TripCurationCGType = {
  __typename?: 'TripCuration';
  /**  제목 */
  title: Scalars['String']['output'];
  /**  여행일정 */
  trips: Array<SurveyCGType>;
};

/**  사용자 타입 */
export type UserCGType = {
  __typename?: 'User';
  /**  FTUERecords */
  FTUERecords: Array<FtueRecordCGType>;
  /**  생성일 */
  createAt?: Maybe<Scalars['DateTime']['output']>;
  /**  여행일정 생성 카운트 */
  createSurveyCount?: Maybe<Scalars['Int']['output']>;
  /**  사용자 이메일 */
  email?: Maybe<Scalars['String']['output']>;
  /**  사용자 ID */
  id: Scalars['ID']['output'];
  /**  위치 약관 동의 여부 */
  isLocationTermsAgreed?: Maybe<Scalars['Boolean']['output']>;
  /**  마지막 로그인 일 */
  lastSignIn?: Maybe<Scalars['DateTime']['output']>;
  /**  좋아요 장소 카운트 */
  likePoiCount?: Maybe<Scalars['Int']['output']>;
  /**  사용자 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /**  사용자 닉네임 */
  nickname?: Maybe<Scalars['String']['output']>;
  /**  역할 */
  role?: Maybe<Scalars['String']['output']>;
};

/**  월드컵 매치 입력 타입 */
export type WorldcupMatchInputCGType = {
  /**  어웨이 존 ID */
  awayZoneId: Scalars['ID']['input'];
  /**  홈 존 ID */
  homeZoneId: Scalars['ID']['input'];
  /**  라운드 */
  round: Scalars['Int']['input'];
  /**  승리 존 ID */
  winnerZoneId: Scalars['ID']['input'];
  /**  월드컵 ID */
  worldcupId: Scalars['ID']['input'];
};

/**  존 타입 */
export type ZoneCGType = {
  __typename?: 'Zone';
  /**  중심 좌표 */
  centerCoords: Array<Scalars['Float']['output']>;
  /**  도시 */
  city?: Maybe<CityCGType>;
  /**  설명 */
  description?: Maybe<Scalars['String']['output']>;
  /**  존 ID */
  id: Scalars['ID']['output'];
  /**  활성 여부 */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**  랜드마크 장소 */
  landmarkPois: Array<PoiCGType>;
  /**  레벨 */
  level?: Maybe<Scalars['Int']['output']>;
  /**  레벨 이름 */
  levelName?: Maybe<Scalars['String']['output']>;
  /**  존 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /**  월드컵 승률 */
  worldcupWinningRate?: Maybe<Scalars['Float']['output']>;
};

export type ZoneRequestInputCGType = {
  name: Scalars['String']['input'];
};

/**  찜카 상품 타입 */
export enum ZzimProductEnumCGType {
  DomesticairlineCGType = 'DOMESTICAIRLINE',
  OverseasairlineCGType = 'OVERSEASAIRLINE',
  RentcarCGType = 'RENTCAR',
  TourtaxiCGType = 'TOURTAXI',
}

/**  찜카 상품 목록 쿼리의 반환 타입 */
export type ZzimProductInfoCGType = {
  __typename?: 'ZzimProductInfo';
  /**  종료 날짜 */
  endDate?: Maybe<Scalars['String']['output']>;
  /**  최저 가격 */
  minPrice?: Maybe<Scalars['String']['output']>;
  /**  상품 이름 */
  name?: Maybe<Scalars['String']['output']>;
  /**  리다이렉트 URL */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /**  시작 날짜 */
  startDate?: Maybe<Scalars['String']['output']>;
  /**  상품 타입 */
  tag?: Maybe<ZzimProductEnumCGType>;
};

/**  찜카 상품 목록 쿼리의 입력 타입 */
export type ZzimProductInputCGType = {
  /**  여행 종료 날짜 */
  eDate?: InputMaybe<Scalars['String']['input']>;
  /**  여행 시작 날짜 */
  sDate?: InputMaybe<Scalars['String']['input']>;
  /**  여행 도시 */
  zone?: InputMaybe<Scalars['String']['input']>;
};

/**  암호화된 SSO 요청 결과 타입 */
export type EncryptSsoRequestResultCGType = {
  __typename?: 'encryptSsoRequestResult';
  /**  암호화된 요청 */
  encryptedRequest?: Maybe<Scalars['String']['output']>;
  /**  상태 */
  status: ResponseStatusCGType;
};

/**  미사용 */
export type UpdateUserInfoCGType = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};
